// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/service/style.less
// module id = 374
// module chunks = 0